import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationDbDismissedDataSelector } from "./recommendationDbDismissedDataSelector";

export const recommendationDbDismissedDataLengthSelector =
  createDraftSafeSelector(
    [recommendationDbDismissedDataSelector],
    (data) => data?.length ?? 0,
  );
